import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export const getDuration = (start: Date, stop: Date | dayjs.Dayjs): duration.Duration => {
  const djStart = dayjs(start);
  const djStop = dayjs(stop);

  return dayjs.duration(djStop.diff(djStart));
};

/**
 * Formats a decimal amount of hours (as used by OCPI, e.g. 2.3623) the same way
 * transaction durations are formatted, so both read alike: `2h 21m 44s`.
 */
export const formatDecimalHours = (hours?: number): string | undefined => {
  // Infinity and negatives come from bad API data; both would format as nonsense.
  if (hours == null || !Number.isFinite(hours) || hours < 0) {
    return undefined;
  }

  const asDuration = dayjs.duration(Math.round(hours * 3600) * 1000);
  return `${Math.floor(asDuration.asHours())}h ${asDuration.format('mm[m] ss[s]')}`;
};
